import React from "react";
import PropTypes from "prop-types";
import styles from "components/common/dropdown-modal.scss";

export const DropdownModal = ({ children, onClose, offsetLeft, offsetTop, visible, width, arrowSide = false }) => (
  visible ? content(children, onClose, offsetLeft, offsetTop, width, arrowSide) : null
);

const content = (children, onClose, offsetLeft, offsetTop, width, arrowSide) => (
  <div className={ styles.wrapper }>
    <div className={ changeArrowSide(arrowSide) } style={ { left: offsetLeft, top: offsetTop, width } }>
      { children }
    </div>
    <div className={ styles.background } onClick={ onClose } />
  </div>
);

const changeArrowSide = (arrowSide) => {
  if (arrowSide) {
    return `${styles.container} ${styles["arrow-side"]}`;
  }
  return styles.container;
};

DropdownModal.propTypes = {
  children: PropTypes.element.isRequired,
  offsetLeft: PropTypes.number,
  offsetTop: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  width: PropTypes.number
};

DropdownModal.defaultProps = {
  offsetLeft: 0,
  offsetTop: 0,
  width: 250
};



// WEBPACK FOOTER //
// ./src/js/components/common/dropdown-modal.jsx